import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'

import once from 'lodash/once.js'
import { useAuthStore } from './store/auth/index.js'
import routes from './routes.js'
import { resolveBeforeRouteResolveHook, redirect } from '~vueutil/router.js'

import { useStore as useNetworkInfoStore } from './store/network-info/index.js'
import { useMeta } from '~vueutil/meta.js'
export { NavigationFailureType, isNavigationFailure } from 'vue-router'

export function createVueRouter (history) {
  const router = createRouter({
    history,
    base: '/',
    linkActiveClass: 'active',
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      return { x: 0, y: 0 }
    },
    routes
  })

  const prefetchData = once(async function (to) {
    const networkInfoStore = useNetworkInfoStore()
    const authStore = useAuthStore()
    const meta = useMeta()

    const { fullPath } = to

    await Promise.all([
      networkInfoStore.prefetchData(),
      authStore.prefetchData()
    ])

    const { websiteUrl } = networkInfoStore.getNetworkInfo()
    meta.setWebsiteUrl(websiteUrl)
    meta.setOgUrl(`${websiteUrl}${fullPath}`)
    meta.setOgTitle('伊甸緣')
    meta.setOgDescription('「伊甸緣LoveMatch」- 專為單身族群而設計的虛實整合平台，專門提供交友戀愛與婚姻家庭的數位內容與引導服務，結合獨家開發的LINE配對技術、遊戲式引導互動、及「CPI配對偏好指數」所創建的健康男女交友互動服務。')

    return {
      auth: authStore.getState()
    }
  })

  router.beforeEach(async (to, from, next) => {
    const { auth } = await prefetchData(to)
    if (auth.id && to.name === 'sign-in') {
      next({
        name: 'home'
      })
    }
    if (!auth.id && to.matched.some(record => record.meta.requiredAuth)) {
      next({
        name: 'home'
      })
      return
    }
    next()
  })

  const PromiseEmptyResolve = Promise.resolve()

  // https://ssr.vuejs.org/zh/guide/data.html#%E5%AE%A2%E6%88%B7%E7%AB%AF%E6%95%B0%E6%8D%AE%E9%A2%84%E5%8F%96-client-data-fetching
  router.beforeResolve(async (to, from, next) => {
    let activated = router.resolve(to).matched
    if (from.name) {
      const matched = router.resolve(to).matched
      const prevMatched = router.resolve(from).matched

      let diffed = false
      activated = matched.filter((c, i) => {
        return diffed || (diffed = (prevMatched[i] !== c))
      })

      if (!activated.length) {
        return next()
      }
    }

    await Promise.all(activated.map(function (matchedRoute) {
      const c = matchedRoute.components.default
      const beforeRouteResolve = resolveBeforeRouteResolveHook(c)

      if (beforeRouteResolve) {
        return beforeRouteResolve(to, from, redirect)
      }

      return PromiseEmptyResolve
    }))

    next()
  })

  return router
}

export function createMemoryRouter () {
  return createVueRouter(createMemoryHistory())
}

export function createWebRouter () {
  return createVueRouter(createWebHistory())
}
